import { type Account } from "@/schemas";

import { queryClient } from "../client";
import { QueryKeys } from "../query-keys";

function isAccountExists(username: string) {
  const accounts = queryClient.getQueryData(
    QueryKeys.accounts.global,
  ) as Account[];
  return accounts.some(
    (account) => account.username === username.replace("@", ""),
  );
}

export { isAccountExists };
